








import { Vue, Component } from 'vue-property-decorator';
import { getRules } from './api';

@Component
export default class Rules extends Vue {
  data: any = '';

  created() {
    this.fetchRules();
  }
  async fetchRules() {
    this.data = `<p><span style="background-color: #f1c40f;"><strong>第六届&ldquo;紫荆杯&rdquo;两岸暨港澳青少年书画大赛</strong></span></p>
<p><span style="background-color: #f1c40f;"><strong>重庆赛区</strong></span></p>
<p style="text-align: left;">邀你共&ldquo;绘&rdquo;花好月圆！</p>
<p>以梦为马，不负韶华。</p>
<p>为增进重庆和港澳地区青少年文化交流，大力弘扬和传承中华优秀传统文化，第六届&ldquo;紫荆杯&rdquo;两岸暨港澳青少年书画大赛（重庆赛区）正式启幕，特邀重庆市广大青少年积极参与本届书画艺术比赛活动。</p>
<p>挥洒五彩画笔，共绘花好月圆。</p>
<p>&nbsp;</p>
<h3><span style="background-color: #f1c40f;"><strong>一、活动组织&nbsp; </strong></span></h3>
<p><span style="background-color: #fbeeb8;">（一）主办单位</span></p>
<p>重庆市政府港澳办、重庆市政府新闻办、重庆市教委、重庆市文联、香港紫荆杂志社</p>
<p><span style="background-color: #fbeeb8;">（二）承办单位</span></p>
<p>香港紫荆杂志社重庆联络站，重庆国际传播中心，九龙坡区、南岸区、渝北区、璧山区、铜梁区、梁平区政府外办（港澳办）、新闻办、教委、文联，巫山县、巫溪县政府外办、政府新闻办、教委、文联，两江新区外办（港澳办）、教育局，高新区外办（港澳办）、公共服务局，重庆市人民小学教育集团、重庆市巴川国际教育集团</p>
<p><span style="background-color: #fbeeb8;">（三）协办单位</span></p>
<p>重庆市人民小学、重庆谢家湾小学、南岸区教师进修学院附属小学校、渝北区龙山小学校、璧山区河边小学、重庆市巴川中学校、铜梁中学、梁平区实验小学、巫山县青少年活动中心、巫溪县珠海实验小学校、两江新区星光学校、高新区树人思贤小学</p>
<p>&nbsp;</p>
<h3><span style="background-color: #f1c40f;"><strong>二、大赛分组及奖项设置</strong></span></h3>
<p>重庆赛区决赛设毛笔书法、中国画、西画三个作品类别，每个类别按照参赛者所处不同学段分设幼儿组、小学组、中学组（以学生报名提交作品时所处学段为准），共九个组别。每个组别设一等奖10名、二等奖20名、三等奖30名，共540名，获奖作品推荐参加第六届&ldquo;紫荆杯&rdquo;两岸暨港澳青少年书画大赛总决赛。各组别另设网络人气奖10名（九个组别共90名）、优秀指导老师奖（由初赛组织单位推荐）50名、杰出指导老师奖50名（由决赛评审决定）、优秀组织单位50个。</p>
<p>&nbsp;</p>
<h3><strong><span style="background-color: #f1c40f;">三、比赛方式</span></strong></h3>
<p><span style="background-color: #fbeeb8;"><strong>（一）初赛（2020年7月15日至9月23日</strong>。</span>重庆赛区初赛由各分赛区自行组织，发动本区县、本系统10所以上中小学和幼儿园学生参赛，组建初赛评选委员会对作品进行评审。每个赛区评出毛笔书法、中国画、西画三类作品幼儿组、小学组、中学组各一等奖10名、二等奖20名共270件获奖作品，12个分赛区共3240件作品进入重庆赛区决赛环节。各分赛区各组别另评选出三等奖30名，作品不送决赛，分赛区获奖学生及指导老师由当地主办单位和人民小学教育集团、巴川国际教育集团自行颁奖并向获奖选手颁发获奖证书。</p>
<p><span style="background-color: #fbeeb8;"><strong>（二）决赛（2020年9月24日至10月13日）</strong>。</span>邀请书画名家担任决赛评委，按照评审细则对3240件决赛参赛作品进行评选。评出毛笔书法、中国画、西画三类作品幼儿组、小学组、中学组各一等奖10名、二等奖20名、三等奖30名，共540件获奖作品，由主办单位向获奖选手和指导老师、优秀组织单位颁发获奖证书、奖牌，获奖作品参加第六届&ldquo;紫荆杯&rdquo;两岸暨港澳青少年书画大赛组委会总决赛。</p>
<p>&nbsp;</p>
<h3><span style="background-color: #f1c40f;"><strong>四、参赛范围及初赛报名</strong></span></h3>

<p><strong>参赛范围：</strong>第六届&ldquo;紫荆杯&rdquo;两岸暨港澳青少年书画大赛（重庆赛区）设九龙坡区、南岸区、渝北区、璧山区、铜梁区、梁平区、巫山县、巫溪县、两江新区、高新区10个区县分赛区和人民小学、巴川国际2个教育集团分赛区。凡属以上区县中小学、幼儿园学生或在两个教育集团所辖学校就读的中小学、幼儿园学生，均可报名参赛。</p>
<p><strong>初赛报名：</strong>各分赛区以学校为单位到本区县、系统指定的承办单位和学校领取参赛报名表，参赛者填写相关信息并提交参赛作品（每一参赛者只可参加一个项目）到本区县、系统指定的承办机构。各参赛者亦可在家长和老师的帮助下登录&ldquo;上游新闻&rdquo;APP，进入本次书画比赛活动专区，<strong>下载报名表</strong>自行打印填写。</p>
<p>&nbsp;</p>
<h3><span style="background-color: #f1c40f;"><strong>五、作品要求</strong></span></h3>
<p><span style="background-color: #fbeeb8;"><strong>（一）毛笔书法类作品</strong></span></p>
<p>1.书体不限，书写题材内容为中华传统诗词文赋。</p>
<p>2.作品宣纸长或宽不可多于3尺（约1米）。</p>
<p>3.如邮寄对联作品，须书写在同一张宣纸上，或将对联宣纸粘贴并齐拓底，拓底后宣纸长或宽不可多于3尺（100&times;55cm）。</p>
<p><span style="background-color: #fbeeb8;"><strong>（二）中国画类作品</strong></span></p>
<p>1.创作形式（水墨画、青绿、浅绛、泼墨、白描等）不限，作品宣纸尺寸不可大于3尺（100&times;55cm）。</p>
<p>2.绘画题材（人物画、山水画、花鸟画等）不限。</p>
<p><span style="background-color: #fbeeb8;"><strong>（三）西画类作品</strong></span></p>
<p>1.创作形式（水彩、油画、蜡笔、素描等）不限，作品画纸尺寸不可小于 30cm x 40cm 及不可大于 50cm x 70cm。</p>
<p>2.绘画题材（人物、风景、动物、物件、梦想等）不限。</p>
<p>3.作品以平面绘画为主，不接受计算机绘图，可使用拼贴或剪贴，但不可多于画面的50%。</p>
<p><span style="background-color: #fbeeb8;"><strong>（四）其他要求</strong></span></p>
<p>1.参赛作品必须为参赛者原创，主题鲜明，内容积极健康向上。</p>
<ol>
<li>2.寄送参加重庆赛区决赛的作品无需装裱。</li>
</ol>
<p>&nbsp;</p>
<h3><span style="background-color: #f1c40f;"><strong>六、网络专题展示</strong></span></h3>
<p>各分赛区决出的一、二等奖获奖作品在重庆赛区网络专题（&ldquo;上游新闻APP&rdquo;、&ldquo;重庆发布&rdquo;、&ldquo;iChongqing爱重庆&rdquo;、&ldquo;光明网重庆频道&rdquo;、&ldquo;智慧八方&rdquo;微信公众号）进行展示，根据网络点赞情况选出各参赛组别最佳网络人气奖10名，网络点赞情况作为专家评审参考。</p>
<p><strong>决赛作品上传</strong>：各分赛区的获奖选手在承办单位组织下，在家长和老师的帮助下登录&ldquo;上游新闻&rdquo;APP，进入本次书画比赛活动专区，依据分赛区及比赛组别的要求，上传电子版作品照片参加网络展示活动。作品照片为清晰的作品正面照，不小于1M，不大于2M，上传的作品要按照区县、系统类别填写好参赛者姓名、所在区县、学校、班级以及作品名称等。</p>
<p>&nbsp;</p>
<h3><span style="background-color: #f1c40f;"><strong>七、颁奖仪式</strong></span></h3>
<p>各分赛区主办单位视情况自行组织初赛颁奖仪式。重庆赛区颁奖仪式暨获奖作品展示具体时间地点待定，对获奖代表进行现场颁奖。第六届&ldquo;紫荆杯&rdquo;两岸暨港澳青少年书画大赛颁奖典礼暨作品展览开幕式暂定于2020年12月在香港（或内地）举行，具体时间及地点待定。</p>
<p>&nbsp;</p>
<h3><span style="background-color: #f1c40f;"><strong>八、其他说明</strong></span></h3>
<p>1.登录&ldquo;上游新闻&rdquo;APP第六届&ldquo;紫荆杯&rdquo;两岸暨港澳青少年书画大赛（重庆赛区）专用页面查看相关比赛资料。</p>
<p>2.各分赛区评出的一、二等奖获奖作品，须按规定上传至&ldquo;上游新闻&rdquo;APP点赞展示。同时将一、二等奖获奖纸质作品邮寄：重庆市南岸区长生桥镇二支路1号，南岸区教师进修学院附属小学校，参加重庆赛区决赛评审。</p>
<p>3.所有参赛实物作品恕不退还，大赛主办机构对获奖作品享有版权，出版获奖作品集及开发一些文创产品，转化比赛成果，弘扬优秀传统文化。</p>
<p>4.各参赛者的个人影像、作品及获奖资料等，可能被上传至主办机构及其附属机构的网页或宣传刊物中作宣传用途，主办机构及其附属机构无须向参赛者另作通知及支付费用。</p>
<p>&nbsp;</p>
<h3 style="margin-bottom: 18px"><span style="background-color: #f1c40f;"><strong>重庆各分赛区初赛实物作品寄送地址及咨询电话：</strong></span></h3>

<h3><span style="background-color: #fbeeb8;"><strong>（1）人民小学教育集团分赛区</strong></span></h3>
<p>地址：重庆市渝中区中山四路11号 重庆市人民小学</p>
<p>电话：<a href="tel:023-63876706">023-63876706</a>（陈老师）<a href="tel:17378369190">17378369190</a>（钱老师）</p>
<h3><span style="background-color: #fbeeb8;"><strong>（2）九龙坡分赛区</strong></span></h3>
<p>地址：重庆市九龙坡区谢家湾正街 重庆谢家湾小学</p>
<p>电话：<a href="tel:18623344921">18623344921</a>（李老师）</p>
<h3><span style="background-color: #fbeeb8;"><strong>（3）南岸分赛区</strong></span></h3>
<p>地址：重庆市南岸区长生桥镇二支路1号 南岸区教师进修学院附属小学校</p>
<p>电话：<a href="tel:13983025799">13983025799</a>（高老师）</p>
<h3><span style="background-color: #fbeeb8;"><strong>（4）渝北分赛区</strong></span></h3>
<p>地址：重庆市渝北区景辉路6号 渝北区龙山小学校</p>

<p>电话：<a href="tel:13648411198">13648411198</a>（李老师）</p>
<h3><span style="background-color: #fbeeb8;"><strong>（5）璧山分赛区</strong></span></h3>
<p>地址：重庆市璧山区河边镇 璧山区河边小学</p>

<p>电话：<a href="tel:13883008616">13883008616</a>（巫老师）</p>
<h3><span style="background-color: #fbeeb8;"><strong>（6）巴川国际教育集团分赛区</strong></span></h3>
<p>地址：重庆市铜梁区东城街道塔山东街666号重庆市巴川中学校</p>

<p>电话：<a href="tel:15823900776">15823900776</a>（梁老师）</p>
<h3><span style="background-color: #fbeeb8;"><strong>（7）铜梁分赛区</strong></span></h3>
<p>地址：重庆市铜梁区巴川镇民主路103号 铜梁中学</p>

<p>电话：<a href="tel:15310185911">15310185911</a>（杨老师）</p>
<h3><span style="background-color: #fbeeb8;"><strong>（8）梁平分赛区</strong></span></h3>
<p>地址：重庆市梁平区梁山街道南园巷41号 梁平区实验小学</p>

<p>电话：<a href="tel:15086637004">15086637004</a>（冉老师）</p>
<h3><span style="background-color: #fbeeb8;"><strong>（9）巫山分赛区</strong></span></h3>
<p>地址：重庆市巫山县高唐街道广东东路333号（东转盘两心四馆） 巫山县青少年活动中心</p>

<p>电话：<a href="tel:18184056888">18184056888</a>（曹老师）</p>
<h3><span style="background-color: #fbeeb8;"><strong>（10）巫溪分赛区</strong></span></h3>
<p>地址：重庆市巫溪县柏杨街道柏杨北路100号 巫溪县珠海实验小学校</p>
<p>电话：<a href="tel:17300260076">17300260076</a>（何老师）</p>
<h3><span style="background-color: #fbeeb8;"><strong>（11）两江新区分赛区</strong></span></h3>
<p>地址：重庆市渝北区靑枫南路20号 两江新区星光学校</p>
<p>电话：<a href="tel:18580557791">18580557791</a>（左老师）</p>
<h3><span style="background-color: #fbeeb8;"><strong>（12）高新区分赛区</strong></span></h3>
<p>地址：重庆市沙坪坝区大学城南一路 高新区树人思贤小学</p>
<p>电话：<a href="tel:13075430041">13075430041</a>（宋老师）</p>
<p>报名表下载、作品上传要求及流程，可咨询上游新闻技术部，微信号&ldquo;yao544658784&rdquo;，联系电话：<a href="tel:17347669335" >17347669335</a></p>
`;
  }
}
